export default __webpack_public_path__ + "static/media/brand-18.39688280.png";